import { QuickpayConstants } from 'constants/quickpay';
import { createAction } from 'redux-actions';

export const getQuickpayAction = createAction(QuickpayConstants.GET_QUICKPAY);
export const getPaymentAccountsAction = createAction(QuickpayConstants.GET_PAYMENT_ACCOUNTS);
export const addPaymentAccountAction = createAction(QuickpayConstants.ADD_PAYMENT_ACCOUNT);
export const getQuickpayStatusAction = createAction(QuickpayConstants.GET_STATUS);
export const makeQuickpayPaymentAction = createAction(QuickpayConstants.MAKE_QUICKPAY_PAYMENT);
export const getQuickpayAutopaysAction = createAction(QuickpayConstants.GET_AUTOPAYS);
export const scheduleQuickpayAutopayAction = createAction(QuickpayConstants.SCHEDULE_AUTOPAY);
